import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CertificateNote_Interface, Empty_CertificateNote_Interface } from 'src/app/Interface/CertificateNote_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { CertificateNoteService } from 'src/app/Service/CertificateNote/CertificateNote.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';

@Component({
  selector: 'app-CertificateNoteAdd',
  templateUrl: './CertificateNoteAdd.component.html',
  styleUrls: ['./CertificateNoteAdd.component.scss']
})
export class CertificateNoteAddComponent implements OnInit {

  Token:String=""

  constructor(
    private CertificateNote_Service:CertificateNoteService,
    private Nav_Service:NavService,
    private Alertify_Service:AlertifyService
  ) { }

  ngOnInit() {
    this.Token=localStorage.getItem('Daro_User_Token');

    this.AddNewCertificateNote=new FormGroup({
      id :new FormControl(),
      Code:new FormControl(null,Validators.required),
      Dsc:new FormControl(null,Validators.required),
    })


    this.Nav_Service.CheckValidPage(this.Token,2212).subscribe(
      data=>{
        
      }
      ,error=>{
        localStorage.clear()
        location.reload();
      }
    )


  }


  //#region  Form Add

  AddNewCertificateNote:FormGroup;

  get_Form_Dsc(){
    return this.AddNewCertificateNote.get('Dsc') as FormControl;
  }

  get_Form_Code(){
    return this.AddNewCertificateNote.get('Code') as FormControl;
  }

  //#endregion

  InProccessing:boolean=false

  SubmitAddNewCertificateNote(){
    var Record:CertificateNote_Interface =Empty_CertificateNote_Interface()
    Record.id=0
    Record.code=this.get_Form_Code().value
    Record.dsc=this.get_Form_Dsc().value
    this.InProccessing=true
    this.CertificateNote_Service.AddCertificateNote(Record,this.Token).subscribe(
      data=>{
        this.InProccessing=false
        if(data.id==-2){
          this.Alertify_Service.ErrorMessage("The entered code already exists in the list")
        }
        else{
          this.AddNewCertificateNote.reset()
          this.Alertify_Service.SuccessMessage("The information was registered successfully")
        }
      },error=>{
        localStorage.clear()
        location.reload();
        
      }
    )
  }

}
